import { FormProvider, useForm } from "react-hook-form";
import { usePractice } from "../usePractice";
import { getBrand } from "../utils/brand";
import { useUpdateCase } from "../useUpdateCase";
import SingleSelectField from "../ui/SingleSelectField";
import AquamationTypeExplainer from "../ui/AquamationTypeExplainer";
import { Helmet } from "react-helmet-async";

function AquamationSelectionForm({ caseData }) {
  const { practice } = usePractice();
  const brand = getBrand(practice?.fields?.brand);
  const { updateCase, isUpdating } = useUpdateCase();
  const methods = useForm();
  const { handleSubmit, watch } = methods;
  const watchAquamationType = watch("aquamationType");

  function onSubmit(data) {
    updateCase({ caseId: caseData.id, fields: data });
  }

  return (
    <div className="container">
      <Helmet>
        <title>{brand.name} - Aquamation Selection</title>
      </Helmet>
      {isUpdating && (
        <div className="loading-screen regular-2xl">Loading...</div>
      )}
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <p>
            <strong>Pet Name: </strong>
            {caseData.fields.petName}
          </p>
          <h3 className="mt-2 text-center">Aquamation Type</h3>

          <SingleSelectField
            name="aquamationType"
            options={[
              { label: "Remains Returned", value: "Remains Returned" },
              { label: "Scattering Service", value: "Scattering Service" },
            ]} // no private available for undecided
            required
          />

          <AquamationTypeExplainer aquamationType={watchAquamationType} />

          <div className="mt-2 text-center">
            <button
              className="button"
              type="submit"
              disabled={!watchAquamationType}
            >
              Submit
            </button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}

export default AquamationSelectionForm;
